import script from "./admin-cadencia.vue?vue&type=script&setup=true&lang=js"
export * from "./admin-cadencia.vue?vue&type=script&setup=true&lang=js"

import "./admin-cadencia.vue?vue&type=style&index=0&id=5a5d4342&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a5d4342"]])

export default __exports__